import { actions as Group } from 'containers/Group';

export function getProgressTestTab(state, groupId) {
  if (Group.isSSV3Group(state, groupId)) {
    return 'Progress';
  }

  return Group.isCNGroup(state, groupId) ? 'Unit Review' : 'Unit Quiz';
}

export function getPTNameWithGroup(state, name, groupId) {
  const isSSV3Group = Group.isSSV3Group(state, groupId);

  return getPTName(name, isSSV3Group);
}

export function getPTName(name, isSSV3Group) {
  const ssv3PtUnits = ['4', '7', '10'];
  const ptNumber = name.replace('Unit Quiz', '').trim();
  if (isSSV3Group) {
    if (ssv3PtUnits.some((u) => name.endsWith(u))) {
      return `Progress Test ${ssv3PtUnits.indexOf(ptNumber) + 1}`;
    }
    return `Unit ${ptNumber} Progress`;
  }

  return `Unit Review ${ptNumber}`;
}



// WEBPACK FOOTER //
// ./data/ProgressTests/accessors.js